import { Component, OnInit, ViewChild } from '@angular/core';
import Swal from 'sweetalert2';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { ServiceProviderService } from 'src/app/services/service-provider.service';
import { MatDatepicker, MatDatepickerInputEvent } from '@angular/material/datepicker';
import { HomeshoppingDataService } from 'src/app/services/homeshopping-data.service';

@Component({
  selector: 'app-billing-promotion',
  templateUrl: './billing-promotion.component.html',
  styleUrls: ['./billing-promotion.component.scss']
})
export class BillingPromotionComponent implements OnInit {

  IsHaveTable: boolean = false;
  customerInvoiceList: any[] = [];
  serviceProviderList: any[] = [];
  transdate: string;
  theirref: string;
  ourref: string;
  dataSource = new MatTableDataSource<any>();
  @ViewChild(MatPaginator, { static: true }) paginatorRef: MatPaginator;

  displayedColumns: string[] = [

    'providerName',
    'billingPromotionDays',
    'transDate',
    'totalAmount'

  ];

  constructor(
    private serviceProviderDataService: ServiceProviderService,
    private homeshoppingDataService: HomeshoppingDataService,
  ) {
  }


  ngOnInit(): void {
    this.searchreset();
  }

  openRequestedCancellationTsDatePicker(index) {
    const clickEvent = new Event('click');
    const elementToClick = document.getElementById('PSclickId' + index);
    if (elementToClick) {
      elementToClick.dispatchEvent(clickEvent);
    }
  }

  openReturnDatePicker(index) {
    const clickEvent = new Event('click');
    const elementToClick = document.getElementById('PEclickId' + index);
    if (elementToClick) {
      elementToClick.dispatchEvent(clickEvent);
    }
  }

  searchreset() {
    this.serviceProviderDataService.getServiceProviderList().subscribe((res: any) => {
      if (res) {
        this.serviceProviderList = res;
        this.dataSource = new MatTableDataSource(this.serviceProviderList);
      }
    });
  }

  update() {
    let temp = this.dataSource.filteredData;

    temp.forEach((itreator) => {
      let date = itreator.billingPromotionStartTs;
      if (date) {
        let dateObject = new Date(date);
        const year = dateObject.getFullYear(); // 2023
        const month = dateObject.getMonth() + 1; // Months are zero-based (0 for January)
        const day = dateObject.getDate(); // 31 

        let startDateModified = year + '-' + month + '-' + day + 'T00:00:00'
        itreator.billingPromotionStartTs = startDateModified;
      }
    });

    temp.forEach((itreator) => {
      let date = itreator.billingPromotionEndTs;
      if (date) {
        let dateObject = new Date(date);

        const year = dateObject.getFullYear(); // 2023
        const month = dateObject.getMonth() + 1; // Months are zero-based (0 for January)
        const day = dateObject.getDate(); // 31 

        let startDateModified = year + '-' + month + '-' + day + 'T23:59:59'

        itreator.billingPromotionEndTs = startDateModified;
      }
    });

    this.homeshoppingDataService.saveBillingPromoConfiguration(temp).subscribe((res) => {
      if (res === 1) {
        this.searchreset();
        Swal.fire(
          'Support Ticket',
          'Your ticket has been logged successfully, one of our agents will be in contact with you.',
          'success'
        );

      }
    });
  }

  setRequestedCancellationTsValue(value: any) {
    // this.requestedCancellationTsDatePicker.select(new Date(value.value));
  }

  setEndCancellationTsValue(value: any) {
    // this.returnDatePicker.select(new Date(value.value));
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

}
